import { FirebaseApp } from 'firebase/app';
import { Firestore, getFirestore, doc, getDoc, setDoc, updateDoc, deleteField, runTransaction } from 'firebase/firestore';
import { IImportDatesService } from '../IImportDatesService';
import { ImportDates } from '../../model/ImportDates';

export class ImportDatesService implements IImportDatesService {
  private database: Firestore;
  private path: string = '';

  constructor(app: FirebaseApp, path: string) {
    this.database = getFirestore(app);
    this.path = path;
  }

  async getLastImportDates(): Promise<ImportDates> {
    const ref = doc(this.database, this.path);
    const snapshot = await getDoc(ref);
    if(snapshot.exists()) {
      return snapshot.data() as ImportDates;
    }
    return { sales: 0 };
  }

  async saveLastImportDates(dates: ImportDates): Promise<void> {
    const ref = doc(this.database, this.path);
    await setDoc(ref, { sales: dates.sales }, { merge: true });
  }

  // Returns false if another import is running (a lock older than maxAgeMs is considered stale)
  async acquireLock(maxAgeMs: number): Promise<boolean> {
    const ref = doc(this.database, this.path);
    return runTransaction(this.database, async (transaction) => {
      const snapshot = await transaction.get(ref);
      const runningSince = snapshot.exists() ? (snapshot.data() as ImportDates).runningSince : undefined;
      const now = Date.now();
      if(runningSince && now - runningSince < maxAgeMs) {
        return false;
      }
      transaction.set(ref, { runningSince: now }, { merge: true });
      return true;
    });
  }

  async releaseLock(): Promise<void> {
    const ref = doc(this.database, this.path);
    await updateDoc(ref, { runningSince: deleteField() });
  }
}
